import { renderPc, renderMobileDeal } from './DrawingIntergrated';

/**
 * @export
 * @class PlanBestDeal
 * 기획전 Best 상품
 */
export default class PlanBestDeal {
  constructor() {
    this.welPlanBest = $('[data-role=_wrapPlanningBest]');
    if (
      !TMON.oApp.htStorage.intergratedDeals ||
      !TMON.oApp.htStorage.intergratedDeals.data ||
      !TMON.oApp.htStorage.intergratedDeals.data.PLAN_BEST_DEALS ||
      !TMON.oApp.htStorage.intergratedDeals.data.PLAN_BEST_DEALS.itemList // API에서 3개 이하일 경우 빈 배열로 내려준다.
    ) {
      this.welPlanBest.remove();
      return;
    }
    this.sHtml = '';
    const {
      intergratedDeals: {
        data: {
          PLAN_BEST_DEALS: { itemList, planningId, planningName },
        },
      },
    } = TMON.oApp.htStorage;
    this.planningId = planningId;
    this.itemList = itemList;
    this.planningName = planningName;
    this.setEvent();

    const planningUrl =
      TMON.htCommonUrl.www_planning || TMON.htCommonUrl.www_m_planning;

    /* 기획전 Render정보 */
    const planRenderInfo = {
      floatYn: '',
      containerRole: '_wrapPlanBestContainer',
      strongWord: this.planningName,
      spanWord: this.planningName,
      spanClass: 'point_color',
      mobileH4Word: ['', 'BEST 상품'],
      h4Word: ['', 'BEST 상품'],
      landingUrl: planningUrl.replace('{}', this.planningId),
      listRole: '_wrapPlanBest',
      tlCode: 'TABST',
      dataSize: this.itemList.length,
      itemList: this.itemList,
      aTagDataRole: 'goPlanDeallist',
      aSpanWord: `${this.planningName} BEST 상품`,
      tlArea: 'dealbest',
      key: 'planBestDeal',
    };

    if (TMON.oApp.sPlatform === 'PW') {
      this.sHtml += renderPc(planRenderInfo);
      this.welPlanBest.html(this.sHtml);
      $('[data-role=_wrapPlanBestContainer]').show();
    } else {
      this.sHtml += renderMobileDeal(planRenderInfo);
    }
  }

  setEvent() {
    $('body').on('click', '[data-role=goPlanDeallist]', e => {
      this.goPlanDeallist(e);
    });
  }

  clearEvent() {
    $('body').off('click', '[data-role=goPlanDeallist]');
  }

  goPlanDeallist(e) {
    if (TMON.view_mode === 'app') {
      e.preventDefault();
      try {
        if (TMON.bIsAndroid && TMON.app.checkVersion('5.5.1') > 0) {
          TMON.app.callApp('webview', 'goIntegratedPlan', this.planningId);
        } else {
          TMON.app.callApp('event', 'goIntegratedPlan', this.planningId);
        }
      } catch (err) {
        console.error(err);
        alert(
          '일시적인 오류로 묶음배송 상품 조회에 실패하였습니다. 잠시 후 다시 시도해 주십시오. 문제가 지속되면 고객센터로 문의를 부탁드립니다.'
        );
      }
    }
  }
}
